import { requestJson } from "../api/apiClient";

function buildQuery(params = {}) {
  const search = new URLSearchParams();
  for (const [key, value] of Object.entries(params)) {
    if (value != null && value !== "") search.set(key, String(value));
  }
  const q = search.toString();
  return q ? `?${q}` : "";
}

export async function fetchVehicleMarketAnalyticsOverview(params = {}) {
  return requestJson(`/api/mobility/vehicle-market/analytics/overview${buildQuery(params)}`);
}

export async function fetchVehicleMarketAnalyticsFilters(params = {}) {
  return requestJson(`/api/mobility/vehicle-market/analytics/filters${buildQuery(params)}`);
}

export async function fetchVehicleMarketAnalyticsClass(classKey, params = {}) {
  return requestJson(
    `/api/mobility/vehicle-market/analytics/classes/${encodeURIComponent(classKey)}${buildQuery(params)}`
  );
}

export async function fetchVehicleMarketAnalyticsComparison(params = {}) {
  return requestJson(
    `/api/mobility/vehicle-market/analytics/class-comparison${buildQuery(params)}`
  );
}

export async function fetchVehicleMarketAnalyticsTrends(classKey, params = {}) {
  return requestJson(
    `/api/mobility/vehicle-market/analytics/classes/${encodeURIComponent(classKey)}/trends${buildQuery(params)}`
  );
}

export async function fetchAdminVehicleMarketAnalyticsOverview(params = {}) {
  return requestJson(
    `/api/admin/mobility/vehicle-market-analytics/overview${buildQuery(params)}`
  );
}
